'use client';
import React, { Dispatch, FC, SetStateAction } from 'react';
import NextImage from 'next/image';
import { useSearchParams } from 'next/navigation';
import { ShopifyVariant } from '@/lib/shopify';
import classNames from 'classnames';
import { ProductVariantCopy } from '@/lib/contentful';
import { getVariantTranslation } from '@/utils/getVariantTranslation';
import { useVariantSelection } from '@/hooks/useVariantSelection';

interface VariantTilesInterface {
  variants: ShopifyVariant[];
  selectedVariant: ShopifyVariant;
  cb: Dispatch<SetStateAction<ShopifyVariant>>;
  productVariantsCopy: ProductVariantCopy | null;
}

const VariantTiles: FC<VariantTilesInterface> = ({
  variants,
  selectedVariant,
  cb,
  productVariantsCopy,
}) => {
  const { handleVariantClick } = useVariantSelection(cb);
  const searchParams = useSearchParams(); // This hook is read-only
  const searchParamsObj: Record<string, string> = {};
  searchParams?.forEach((value, key) => (searchParamsObj[key] = value));

  const label = getVariantTranslation(productVariantsCopy, 'Style');
  const title = getVariantTranslation(
    productVariantsCopy,
    selectedVariant.title,
  );

  return (
    <div className="flex flex-col mb-3">
      <p className="mb-1">{`${label}: ${selectedVariant && title}`}</p>
      <div className="flex gap-2">
        {variants.map((v: ShopifyVariant) => {
          const isSelected = v.id === selectedVariant.id;
          const { availableForSale } = v;
          return (
            <div
              key={v.id}
              onClick={() => handleVariantClick(v)}
              className={classNames(
                'h-auto w-auto',
                isSelected ? 'border-2 border-indigo' : '',
                availableForSale ? 'cursor-pointer' : 'cursor-not-allowed',
              )}
            >
              {availableForSale ? (
                <NextImage
                  src={v.image.url}
                  width="72"
                  height="72"
                  alt={v.image.altText}
                />
              ) : (
                // empty out of stock div with strikethru
                <div className="h-[72px] w-[72px] bg-gradient-to-tr from-grey from-[calc(50%-1px)] via-[#514f4e] via-[1px] to-grey to-[calc(50%+1px)]"></div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VariantTiles;
